
<div class="shipping-page">

  <!-- INTESTAZIONE PRINCIPALE -->

  <header class="shipping-page-header">
    <div class="shipping-page-heading">
      <div class="shipping-page-heading-icon">
        <i class="pi pi-truck"></i>
      </div>

      <div class="shipping-page-heading-text">
        <h1>Gestione consegne</h1>
        <p>
          Consulta le spedizioni, verifica le consegne
          e gestisci le operazioni disponibili.
        </p>
      </div>
    </div>

    <!-- VISIBILE SOLO CON createShipping -->

    <p-button
      *ngIf="hasCreatePermission"
      label="Nuova Spedizione"
      icon="pi pi-plus"
      styleClass="shipping-primary-button"
      (onClick)="createNewShipping()"
    ></p-button>
  </header>

  <!-- ELENCO DELLE SPEDIZIONI -->

  <ng-container *ngIf="selectedShippingId === undefined">

    <div class="shipping-list-heading">
      <div>
        <h2>Spedizioni disponibili</h2>
        <p>
          Seleziona una spedizione per visualizzare
          il registro delle relative consegne.
        </p>
      </div>

      <span class="shipping-list-count">
        {{ shippings.length }}
        {{ shippings.length === 1 ? 'Spedizione' : 'Spedizioni' }}
      </span>
    </div>

    <div class="shipping-cards-list">

      <div
        class="shipping-item-card"
        *ngFor="let shipping of shippings"
        (click)="openShipping(shipping)"
        (keydown.enter)="openShipping(shipping)"
        (keydown.space)="$event.preventDefault(); openShipping(shipping)"
        tabindex="0"
        role="button"
        [attr.aria-label]="'Apri spedizione ' + shipping.shipping"
      >

        <div class="shipping-item-icon">
          <i class="pi pi-box"></i>
        </div>

        <div class="shipping-item-content">

          <div class="shipping-item-title-row">
            <h3>{{ shipping.shipping }}</h3>
          </div>

          <div class="shipping-item-dates">
            <span>
              <i class="pi pi-calendar"></i>
              Dal
              {{ shipping.validFromDate | date: 'dd/MM/yyyy' }}
            </span>

            <span>
              <i class="pi pi-calendar"></i>
              Al
              {{ shipping.validToDate | date: 'dd/MM/yyyy' }}
            </span>
          </div>

          <div class="shipping-item-statistics">

            <div class="shipping-item-stat">
              <i class="pi pi-users"></i>
              <span>
                <strong>
                  {{ getShippingRecipientsCount(shipping.shippingId!) }}
                </strong>
                Destinatari
              </span>
            </div>

            <div class="shipping-item-stat shipping-item-stat-success">
              <i class="pi pi-check-circle"></i>
              <span>
                <strong>
                  {{ getShippingDeliveredCount(shipping.shippingId!) }}
                </strong>
                Consegnate
              </span>
            </div>

            <div class="shipping-item-stat shipping-item-stat-warning">
              <i class="pi pi-clock"></i>
              <span>
                <strong>
                  {{ getShippingPendingCount(shipping.shippingId!) }}
                </strong>
                Da consegnare
              </span>
            </div>

          </div>
        </div>

        <div class="shipping-item-arrow">
          <i class="pi pi-chevron-right"></i>
        </div>

      </div>

      <div
        class="shipping-empty-card"
        *ngIf="shippings.length === 0"
      >
        <i class="pi pi-inbox"></i>
        <h3>Nessuna spedizione disponibile</h3>
        <p>
          Al momento non sono presenti spedizioni da visualizzare.
        </p>
      </div>

    </div>
  </ng-container>

  <!-- DETTAGLIO DELLA SPEDIZIONE SELEZIONATA -->

  <ng-container *ngIf="selectedShipping as shipping">

    <div class="shipping-detail-navigation">
      <p-button
        label="Torna alle spedizioni"
        icon="pi pi-arrow-left"
        [outlined]="true"
        styleClass="shipping-back-button"
        (onClick)="closeShipping()"
      ></p-button>
    </div>

    <!-- RIEPILOGO SPEDIZIONE -->

    <section class="shipping-section-card shipping-detail-card">

      <div class="shipping-detail-heading">
        <div class="shipping-detail-heading-main">
          <div class="shipping-section-icon">
            <i class="pi pi-box"></i>
          </div>

          <div>
            <h2>{{ shipping.shipping }}</h2>
            <p>Dettaglio della spedizione selezionata</p>
          </div>
        </div>

        <!-- VISIBILE SOLO CON removeShipping -->

        <p-button
          *ngIf="hasDeletePermission"
          icon="pi pi-trash"
          label="Elimina spedizione"
          severity="danger"
          [outlined]="true"
          styleClass="shipping-delete-button"
          (onClick)="removeShipping(shipping)"
        ></p-button>
      </div>

      <div class="shipping-detail-info">

        <div class="shipping-detail-info-item">
          <i class="pi pi-calendar"></i>
          <div>
            <span>Valida dal</span>
            <strong>
              {{ shipping.validFromDate | date: 'dd/MM/yyyy' }}
            </strong>
          </div>
        </div>

        <div class="shipping-detail-info-item">
          <i class="pi pi-calendar"></i>
          <div>
            <span>Valida fino al</span>
            <strong>
              {{ shipping.validToDate | date: 'dd/MM/yyyy' }}
            </strong>
          </div>
        </div>

        <div class="shipping-detail-info-item">
          <i class="pi pi-users"></i>
          <div>
            <span>Destinatari</span>
            <strong>
              {{ getShippingRecipientsCount(shipping.shippingId!) }}
            </strong>
          </div>
        </div>

        <div class="shipping-detail-info-item">
          <i class="pi pi-check-circle"></i>
          <div>
            <span>Consegnate</span>
            <strong>
              {{ getShippingDeliveredCount(shipping.shippingId!) }}
            </strong>
          </div>
        </div>

      </div>
    </section>

    <!-- RICERCA ISCRITTO: SOLO CON deliverShipping -->

    <section
      class="shipping-section-card"
      *ngIf="hasDeliveredPermission"
    >
      <div class="shipping-section-heading">
        <div class="shipping-section-icon">
          <i class="pi pi-search"></i>
        </div>

        <div>
          <h2>Ricerca iscritto</h2>
          <p>
            Inserisci la matricola per verificare
            la consegna relativa a questa spedizione.
          </p>
        </div>
      </div>

      <div class="shipping-verification-content">

        <form
          [formGroup]="formGroup"
          class="shipping-search-form"
          (ngSubmit)="validateRegisterNumber()"
        >
          <label for="shipping-code">
            Matricola iscritto
          </label>

          <div class="shipping-search-controls">

            <div class="shipping-code-input">
              <i class="pi pi-id-card"></i>

              <input
                id="shipping-code"
                type="text"
                pInputText
                formControlName="search"
                placeholder="Inserisci la matricola"
                autocomplete="off"
                autocapitalize="off"
                spellcheck="false"
              />
            </div>

            <p-button
              label="Verifica"
              icon="pi pi-search"
              [disabled]="formGroup.invalid"
              styleClass="shipping-verify-button"
              (onClick)="validateRegisterNumber()"
            ></p-button>

          </div>

          <small class="shipping-code-hint">
            Inserisci la matricola dell'iscritto così come
            risulta nell'anagrafica.
          </small>
        </form>

        <div
          class="shipping-verification-result"
          *ngIf="searchDone"
        >

          <ng-container *ngIf="isValid; else notValid">

            <div class="shipping-result shipping-result-success">
              <i class="pi pi-check-circle"></i>

              <div>
                <strong>Iscritto riconosciuto</strong>
                <span>
                  La matricola è stata riconosciuta.
                  Puoi procedere con la registrazione della consegna.
                </span>
              </div>

              <p-tag
                severity="success"
                value="Valido"
              ></p-tag>
            </div>

          </ng-container>

          <ng-template #notValid>

            <ng-container *ngIf="hasAlreadyDelivered; else error">

              <div class="shipping-result shipping-result-warning">
                <i class="pi pi-info-circle"></i>

                <div>
                  <strong>Nessuna consegna da effettuare</strong>
                  <span>
                    Non risultano consegne in sospeso
                    per questa matricola e questa spedizione.
                  </span>
                </div>

                <p-tag
                  severity="warning"
                  value="Nessuna consegna"
                ></p-tag>
              </div>

            </ng-container>

            <ng-template #error>

              <div class="shipping-result shipping-result-danger">
                <i class="pi pi-exclamation-circle"></i>

                <div>
                  <strong>Matricola non riconosciuta</strong>
                  <span>
                    La matricola inserita non corrisponde
                    a nessun iscritto.
                  </span>
                </div>

                <p-tag
                  severity="danger"
                  value="Non valido"
                ></p-tag>
              </div>

            </ng-template>
          </ng-template>
        </div>

      </div>
    </section>

    <!-- REGISTRO DELLA SPEDIZIONE SELEZIONATA -->

    <section class="shipping-section-card shipping-register-card">

      <div class="shipping-register-header">

        <div class="shipping-section-heading">
          <div class="shipping-section-icon">
            <i class="pi pi-list"></i>
          </div>

          <div>
            <h2>Registro delle consegne</h2>
            <p>
              Consulta lo stato delle consegne
              per {{ shipping.shipping }}.
            </p>
          </div>
        </div>

        <div class="shipping-register-summary">

          <div class="shipping-summary-item">
            <strong>
              {{ getShippingRecipientsCount(shipping.shippingId!) }}
            </strong>
            <span>Destinatari</span>
          </div>

          <div class="shipping-summary-divider"></div>

          <div class="shipping-summary-item">
            <strong>
              {{ getShippingDeliveredCount(shipping.shippingId!) }}
            </strong>
            <span>Consegnate</span>
          </div>

          <div class="shipping-summary-divider"></div>

          <div class="shipping-summary-item">
            <strong>
              {{ getShippingPendingCount(shipping.shippingId!) }}
            </strong>
            <span>In attesa</span>
          </div>

        </div>
      </div>

      <div class="shipping-table-container">

        <p-table
          #dt
          [value]="selectedShippingUsers"
          [scrollable]="true"
          scrollDirection="both"
          [globalFilterFields]="['user.name', 'user.lastName', 'user.registerNumber']"
          styleClass="p-datatable-sm shipping-data-table"
          [style]="{ width: '100%' }"
        >

          <ng-template pTemplate="header">
            <tr>

              <th class="shipping-name-column">
                Nome e cognome
              </th>

              <th class="shipping-matricola-column">
                Matricola
              </th>

              <th class="shipping-location-column">
                Sede
              </th>

              <th class="shipping-delivery-column">
                <div class="shipping-column-heading">

                  <div class="shipping-column-title">
                    <i class="pi pi-box"></i>
                    <span>{{ shipping.shipping }}</span>
                  </div>

                  <div class="shipping-column-dates">
                    <span>
                      <i class="pi pi-calendar"></i>
                      Dal
                      {{ shipping.validFromDate | date: 'dd/MM/y' }}
                    </span>

                    <span>
                      Al
                      {{ shipping.validToDate | date: 'dd/MM/y' }}
                    </span>
                  </div>

                </div>
              </th>

            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-subscriber>
            <tr>

              <td class="shipping-name-cell">
                <div class="shipping-user-cell">

                  <div class="shipping-user-avatar">
                    <i class="pi pi-user"></i>
                  </div>

                  <span>
                    {{ subscriber.user.name }}
                    {{ subscriber.user.lastName }}
                  </span>

                </div>
              </td>

              <td class="shipping-matricola-cell">
                <span class="shipping-matricola-value">
                  {{ subscriber.user.registerNumber }}
                </span>
              </td>

              <td class="shipping-location-cell">
                <div class="shipping-location-value">
                  <i class="pi pi-map-marker"></i>

                  <span>
                    {{ subscriber.user.headquarter }}
                  </span>
                </div>
              </td>

              <!-- NESSUNA CONSEGNA -->

              <td
                *ngIf="
                  subscriber.shippingsMap[shipping.shippingId!] ===
                  undefined
                "
                class="shipping-status-cell"
              >
                <div
                  class="shipping-delivery-status shipping-status-none"
                >
                  <i class="pi pi-minus-circle"></i>
                  <span>Nessuna consegna</span>
                </div>
              </td>

              <!-- CONSEGNATO -->

              <td
                *ngIf="
                  subscriber.shippingsMap[shipping.shippingId!] !==
                    undefined &&
                  subscriber.shippingsMap[shipping.shippingId!]
                    .delivered
                "
                class="shipping-status-cell"
              >
                <div
                  class="shipping-delivery-status shipping-status-delivered"
                >
                  <i class="pi pi-check-circle"></i>

                  <div class="shipping-delivery-status-text">
                    <strong>Consegnato</strong>

                    <span>
                      {{
                        subscriber.shippingsMap[
                          shipping.shippingId!
                        ].updateDate | date: 'dd/MM/y'
                      }}
                    </span>

                    <small>
                      Da:
                      {{
                        subscriber.shippingsMap[
                          shipping.shippingId!
                        ].deliverer
                      }}
                    </small>
                  </div>

                </div>
              </td>

              <!-- NON CONSEGNATO -->

              <td
                *ngIf="
                  subscriber.shippingsMap[shipping.shippingId!] !==
                    undefined &&
                  !subscriber.shippingsMap[shipping.shippingId!]
                    .delivered
                "
                class="shipping-status-cell"
              >
                <div
                  class="shipping-delivery-status shipping-status-pending"
                >
                  <i class="pi pi-clock"></i>
                  <span>Non consegnato</span>
                </div>
              </td>

            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="4">

                <div class="shipping-empty-state">
                  <i class="pi pi-users"></i>

                  <strong>Nessun destinatario disponibile</strong>

                  <span>
                    Non risultano iscritti associati
                    a questa spedizione.
                  </span>
                </div>

              </td>
            </tr>
          </ng-template>

        </p-table>
      </div>

    </section>

  </ng-container>

</div>

<!-- DIALOG REGISTRA CONSEGNA -->

<p-dialog
  header="Registra consegna"
  [draggable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [modal]="true"
  *ngIf="user !== undefined && hasDeliveredPermission"
  [visible]="user !== undefined && hasDeliveredPermission"
  (visibleChange)="!$event && clearSelection()"
  (onHide)="clearSelection()"
  [style]="{ width: 'min(580px, 95vw)' }"
  styleClass="shipping-management-dialog"
>
  <div class="shipping-dialog-content">

    <div class="shipping-dialog-intro">
      <div class="shipping-dialog-intro-icon">
        <i class="pi pi-box"></i>
      </div>

      <div>
        <h3>
          Consegna per:
          {{ user.name }} {{ user.lastName }} -
          {{ user.headquarter }} -
          {{
            user.role.toLowerCase() === 'convenzione'
              ? 'Convenzione'
              : 'Iscritto'
          }}
        </h3>

        <p>Seleziona la consegna.</p>
      </div>
    </div>

    <div class="shipping-dialog-delivery-list">

      <ng-container *ngFor="let del of toDeliver">
        <div class="shipping-dialog-delivery-item">

          <p-toggleButton
            [(ngModel)]="toDeliverMap[del.shippingId]"
            [onLabel]="
              shippingsMap[del.shippingId].shipping +
              ' - Consegna effettuata'
            "
            [offLabel]="
              shippingsMap[del.shippingId].shipping +
              ' - Non consegnato'
            "
            offIcon="pi pi-times"
            onIcon="pi pi-check"
          ></p-toggleButton>

        </div>
      </ng-container>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="shipping-dialog-actions">

      <p-button
        label="Conferma"
        icon="pi pi-check"
        severity="success"
        (onClick)="setAsDelivered()"
      ></p-button>

    </div>
  </ng-template>
</p-dialog>

<!-- DIALOG NUOVA SPEDIZIONE: SOLO CON createShipping -->

<p-dialog
  header="Nuova spedizione"
  [draggable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [modal]="true"
  *ngIf="creating !== undefined && hasCreatePermission"
  [visible]="creating !== undefined && hasCreatePermission"
  (visibleChange)="!$event && (creating = undefined)"
  (onHide)="creating = undefined"
  [style]="{ width: 'min(660px, 95vw)' }"
  [breakpoints]="{ '640px': '96vw' }"
  styleClass="shipping-management-dialog shipping-creation-dialog"
>
  <div class="shipping-dialog-content">

    <div class="shipping-dialog-intro">
      <div class="shipping-dialog-intro-icon">
        <i class="pi pi-truck"></i>
      </div>

      <div>
        <h3>Dettagli della spedizione</h3>

        <p>
          Definisci il nome, gli utenti destinatari
          e il periodo di validità.
        </p>
      </div>
    </div>

    <div class="shipping-dialog-field">
      <label for="shipping-title">
        Nome spedizione
      </label>

      <input
        id="shipping-title"
        type="text"
        pInputText
        [(ngModel)]="creating.shipping.shipping"
        placeholder="Inserisci il nome della spedizione"
      />
    </div>

    <div class="shipping-dialog-field">
      <label>Destinatari</label>

      <p-button
        icon="pi pi-users"
        [label]="creating.userIds.length + ' utenti'"
        [outlined]="true"
        styleClass="shipping-assign-button"
        (onClick)="assignUsers()"
      ></p-button>
    </div>

    <div class="shipping-date-grid">

      <div class="shipping-dialog-field shipping-date-field">
        <label for="shipping-valid-from">
          Valido da
        </label>

        <p-calendar
          inputId="shipping-valid-from"
          [(ngModel)]="creating.shipping.validFromDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [readonlyInput]="true"
          appendTo="body"
          styleClass="shipping-date-picker"
          placeholder="Seleziona data iniziale"
        ></p-calendar>
      </div>

      <div class="shipping-dialog-field shipping-date-field">
        <label for="shipping-valid-to">
          Valido fino a
        </label>

        <p-calendar
          inputId="shipping-valid-to"
          [(ngModel)]="creating.shipping.validToDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [readonlyInput]="true"
          appendTo="body"
          styleClass="shipping-date-picker"
          placeholder="Seleziona data finale"
        ></p-calendar>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="shipping-dialog-actions">

      <p-button
        label="Conferma"
        icon="pi pi-check"
        severity="success"
        (onClick)="confirmCreate()"
      ></p-button>

    </div>
  </ng-template>
</p-dialog>
